import React from 'react';
import PropTypes from 'prop-types';
import styles from '../hiwTemplate.module.scss';

function HiwStepIndicator({ isCurrent, ...props }) {
  return (
    <li
      className={`${styles.hiwTemplateStepIndicator} ${
        isCurrent && styles.hiwTemplateStepIndicatorActive
      }`}
    >
      <button {...props} aria-current={isCurrent} type="submit">
        <span />
      </button>
    </li>
  );
}

HiwStepIndicator.propTypes = {
  isCurrent: PropTypes.bool.isRequired,
};

function HiwIndicators(props) {
  return <ul className={styles.hiwTemplateIndicators} {...props} />;
}

export { HiwIndicators, HiwStepIndicator };
